import React from 'react';

const SHORT = {
  options: [[/platform/i, 'Platforms'], [/.*/, 'Options']],
  fabrics: [[/fabric/i, 'Fabrics'], [/network|wiring/i, 'Network & Wiring'], [/privacy/i, 'Privacy & Light'], [/moisture|room/i, 'Room Considerations']],
  uses: [[/.*/, 'Applications']],
  care: [[/troubleshoot/i, 'Troubleshooting'], [/.*/, 'Care']],
  measure: [[/planning/i, 'Planning & Installation'], [/.*/, 'Measuring & Installation']],
  topic: [[/oversized/i, 'Oversized']],
};

// Short standard label for a guide block, falling back to its own heading.
export const quickLabel = (kind, title = '') => (SHORT[kind] || []).find(([re]) => re.test(title))?.[1] || title;

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const header = document.querySelector('[data-testid="navbar"]')?.offsetHeight || 80;
  const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - header - 16, behavior: reduce ? 'auto' : 'smooth' });
  window.history.replaceState(null, '', `#${id}`);
  el.setAttribute('tabindex', '-1');
  el.focus({ preventScroll: true });
};

// Compact "On this page" jump-link row shared by all long product guides.
export const GuideQuickLinks = ({ links }) => links.length > 1 && (
  <nav aria-label="On this page" className="mt-10 -mx-1" data-testid="guide-quick-links">
    <ul className="flex flex-wrap gap-2 px-1 py-1">
      {links.map((l) => (
        <li key={l.id} className="flex-shrink-0">
          <a href={`#${l.id}`} onClick={(e) => { e.preventDefault(); scrollToId(l.id); }}
            className="inline-block whitespace-nowrap px-3 py-1.5 border border-neutral-300 text-xs font-medium uppercase tracking-wide text-neutral-700 hover:border-neutral-900 hover:text-neutral-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-900 transition-colors"
            data-testid={`guide-quick-link-${l.key}`}>{l.label}</a>
        </li>
      ))}
    </ul>
  </nav>
);
